export const ParcoTheme = {
    global: {
        backgroundImage: "linear-gradient(#054667, #0976ad)",
        fontFamily: "Montserrat, sans-serif",
        color: "white"
    },

    button: {
        color: "#1d4564"
    },

    formNav: {
        color: "#1d4564"
    }
}